import $ from 'jquery';

class DataService {
    static loadData(dataPath) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                type: 'GET',
                url: dataPath,
                contentType:'application/json',
                dataType:'json'
            }).done(resolve).fail(reject);
        });
    }
}

export default DataService;


/** WEBPACK FOOTER **
 ** ./src/services/dataService.js
 **/